import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statuses: [],
  status: {
    id: 0,
    name: "",
    description: "",
    color: "",
    status: false,
  },
  statusValidation: {
    isValid: true,
    name: {
      isValid: true,
      errorMessage: "El campo nombre no debe estar vacio",
    },
    description: {
      isValid: true,
      errorMessage: "El campo descripción no debe estar vacio",
    },
    color: {
      isValid: true,
      errorMessage: "El campo color no debe estar vacio",
    },
  },
};

const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    restartState(state) {
      state.status = {};
      state.statuses = [];
    },
    setStatuses(state, actions) {
      state.statuses = actions.payload.statuses;
      state.status = {};
    },
    setStatus(state, actions) {
      state.status = actions.payload.status;
      state.statuses = [];
    },
    modifyPropertyValue(state, actions) {
      state.status[actions.payload.id] = actions.payload.value;
    },
    setStatusValidation(state, actions) {
      state.statusValidation = {
        name: {
          ...state.statusValidation.name,
          isValid: actions.payload.name !== "",
        },
        description: {
          ...state.statusValidation.description,
          isValid: actions.payload.description !== "",
        },
        color: {
          ...state.statusValidation.color,
          isValid: actions.payload.color !== "",
        },
      };
      state.statusValidation.isValid =
        state.statusValidation.description.isValid;
    },
    setFieldValid(state, actions) {
      state.statusValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const statusActions = statusSlice.actions;
export default statusSlice;
